export enum TagType {
  TAG = 'tag',
  FACET = 'facet',
}

export interface Tag {
  ID: string;
  Label: string;
  Type: TagType;
  Value?: string; // value applied to a specific object
}

export type TagId = string;

export interface TagAssignment {
  TagID: TagId;
  Value?: string;
}

export interface Facet {
  ID: string;
  Label: string;
}

// A facet tag that has been applied to an object with a value
export type FacetValue = Tag & { Type: TagType.FACET; Value: string };

export function normalizeTag(t: Tag): Tag {
  return {...t, Label: t.Label.toUpperCase(), Value: t.Value?.toUpperCase()};
}
